import { render, staticRenderFns } from "./priceViewDialog.vue?vue&type=template&id=0f54f263&"
import script from "./priceViewDialog.vue?vue&type=script&lang=js&"
export * from "./priceViewDialog.vue?vue&type=script&lang=js&"
import style0 from "./priceViewDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f54f263')) {
      api.createRecord('0f54f263', component.options)
    } else {
      api.reload('0f54f263', component.options)
    }
    module.hot.accept("./priceViewDialog.vue?vue&type=template&id=0f54f263&", function () {
      api.rerender('0f54f263', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/OpenPriceBatch/components/priceViewDialog.vue"
export default component.exports